// => Update contacts
const UPDATE_CONTACTS = "/contacts";

export const contactEndpoints = {
    UPDATE_CONTACTS,
};
